// we need our modal component
import AppModal from "@/common/qModal.vue";
import i18n from "@/i18n";
import $ from "jquery";
import moment from "moment";
import * as objectFitImages from "object-fit-images";

const Modal = {
  // every plugin for Vue.js needs install method
  // this method will run after Vue.use(<your-plugin-here>) is executed
  EventBus: null,
  install(Vue) {
    // We must create new Eventbus
    // which is just another Vue instance that will be listening for and emiting events from our main instance
    // this EventBus will be available as Modal.EventBus
    this.EventBus = new Vue();

    // making our modal component global
    Vue.component("QModal", AppModal);
    // Register a global custom directive called `v-focus`
    Vue.directive("image-fit", {
      // When the bound element is inserted into the DOM...
      inserted: (element: any) => {
        // Focus the element
        objectFitImages(element);
      },
      update: (element: any) => {
        // Focus the element
        objectFitImages(element);
      },
    });
    Vue.directive("js-togglebtn", {
      // When the bound element is inserted into the DOM...
      inserted: (element: any) => {
        // Focus the element
        $(element).click(() => {
          $(element).next().slideToggle();
          $(element).toggleClass("open");
        });
      },
    });

    Vue.directive("convert-half-width", {
      inserted(element) {
        element.addEventListener("focusout", function(event) {
          event.target.value = event.target.value.replace(
            /[０-９]/g,
            function(match) {
              return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
            },
          );
        });
        element.addEventListener("input", function(event) {
          event.target.value = event.target.value.replace(
            /[０-９]/g,
            function(match) {
              return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
            },
          );
        });
      },
    });

    Vue.directive("error-state", {
      // When the bound element is inserted into the DOM...
      componentUpdated: (element: any, binding) => {
        // Focus the element
        const errors = binding.value[0];
        const key = binding.value[1];
        if (errors && errors[key] && errors[key].length > 0) {
          element.setAttribute("status", "error");
        } else {
          element.setAttribute("status", "");
        }
      },
    });

    Vue.filter("date", function(value, format = "YYYY-MM-DD") {
      if (!value) {
        return "";
      } else {
        return moment(value).format(format);
      }
    });

    Vue.filter("datetime", function(value, format = "YYYY-MM-DD HH:mm") {
      if (!value) {
        return "";
      } else {
        return moment(value).format(format);
      }
    });

    Vue.filter("time", function(value, format = "HH:mm") {
      if (!value) {
        return "";
      } else {
        return moment(value).format(format);
      }
    });

    Vue.filter("number", function(value) {
      if (value === 0) { return 0; } else if (!value) { return ""; }
      return Intl.NumberFormat().format(Math.ceil(value));
    });

    Vue.filter("float", function(value) {
      if (value === 0) { return 0; } else if (!value) { return ""; }
      return Intl.NumberFormat().format(value);
    });

    Vue.filter("postal", (value: string) => {
      if (value) {
        if (value.includes("-")) {
          return value;
        } else {
          return value.slice(0, 3) + "-" + value.slice(3, value.length);
        }
      }
      return "";
    });

    Vue.filter("phone", (value: string) => {
      if (value) {
        const trimmedNumber = value.replace(/\D/g, "");
        return trimmedNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
      return "";
    });
    // exposing global $modal object with method show()
    // method show() takes object params as argument
    // inside this object we can have modal title, text, styles... and also our callback confirm function
    Vue.prototype.$modal = {
      showDelete: (parameters) => {
        // if we use this.$modal.show(parameters) inside our original Vue instance
        // we will emit 'show' event with parameters 'parameters'
        parameters = parameters || {};
        parameters.type = "error";
        parameters.confirmClass = "Red";
        this.EventBus.$emit("show", parameters);
      },
      showCancel: (parameters) => {
        // if we use this.$modal.show(parameters) inside our original Vue instance
        // we will emit 'show' event with parameters 'parameters'
        parameters = parameters || {};
        parameters.type = "info";
        parameters.confirmText = parameters.confirmText
          ? parameters.confirmText
          : i18n.ja.common.buttons.yes;
        parameters.cancelText = parameters.cancelText
          ? parameters.cancelText
          : i18n.ja.common.buttons.no;
        this.EventBus.$emit("show", parameters);
      },
      show: (parameters) => {
        this.EventBus.$emit("show", parameters);
      },
    };
  },
};
declare interface VModal {
  showDelete(parameters?: any): void;
  showCancel(parameters?: any): void;
  show(parameters?: any): void;
}
declare module "vue/types/vue" {
  interface Vue {
    $modal: VModal;
  }
}
export default Modal;
